import axios from "axios";
import Config from "src/config";

const BASE = Config.dev ? Config.url_dev : Config.urlBackend;

// platform opcional: sem ela, o backend retorna Facebook + Instagram mesclados
export const listSocialPosts = (clienteId, platform) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/meta/comments/posts?cliente_id=${clienteId}${platform ? `&platform=${platform}` : ''}`
    });
};

export const listSocialCommentsByPost = (clienteId, platform, postId) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/meta/comments/posts/${encodeURIComponent(postId)}?cliente_id=${clienteId}&platform=${platform}`
    });
};

export const replySocialComment = (data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/meta/comments/reply`,
        data
    });
};

export const setSocialCommentHidden = (data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/meta/comments/hidden`,
        data
    });
};

export const deleteSocialComment = (params) => {
    return axios({
        method: "delete",
        url: `${BASE}/api/v2/meta/comments`,
        data: params
    });
};

export const syncSocialComments = (data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/meta/comments/sync`,
        data
    });
};
